module.exports = __webpack_public_path__ + "static/media/excited.c5cb6d64.jpg";